import React from 'react';
import { MapPin, Phone, Mail, Clock, Award, Link as LinkIcon } from 'lucide-react';
import { stockists } from '../mockData';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const Partners = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Our Partners</h1>
          <p className="text-xl text-blue-100 max-w-2xl">
            Meet our trusted network of distribution partners across Jharkhand
          </p>
        </div>
      </div>

      {/* Stockists Details */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Our Top Distribution Partners
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Authorized distributors ensuring quality product availability
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {stockists.map((stockist) => (
              <Card key={stockist.id} className="border-2 hover:shadow-xl transition-all hover:-translate-y-2 group">
                <CardContent className="p-0">
                  <div className="relative h-48 overflow-hidden rounded-t-lg">
                    <img
                      src={stockist.image}
                      alt={stockist.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                    <div className="absolute bottom-4 left-4 text-white">
                      <h3 className="text-2xl font-bold mb-1">{stockist.name}</h3>
                      <p className="text-sm text-blue-200">Established {stockist.established}</p>
                    </div>
                  </div>

                  <div className="p-6">
                    <div className="space-y-4 mb-6">
                      <div className="flex items-start gap-3">
                        <MapPin className="w-5 h-5 text-blue-600 flex-shrink-0 mt-1" />
                        <div>
                          <p className="font-semibold text-gray-900 mb-1">Address</p>
                          <p className="text-gray-700 text-sm leading-relaxed">{stockist.address}</p>
                        </div>
                      </div>

                      <div className="flex items-start gap-3">
                        <Phone className="w-5 h-5 text-blue-600 flex-shrink-0 mt-1" />
                        <div>
                          <p className="font-semibold text-gray-900 mb-1">Phone</p>
                          <a href={`tel:${stockist.phone}`} className="text-blue-600 hover:text-blue-700 text-sm">
                            {stockist.phone}
                          </a>
                        </div>
                      </div>

                      <div className="flex items-start gap-3">
                        <Mail className="w-5 h-5 text-blue-600 flex-shrink-0 mt-1" />
                        <div>
                          <p className="font-semibold text-gray-900 mb-1">Email</p>
                          <a href={`mailto:${stockist.email}`} className="text-blue-600 hover:text-blue-700 text-sm break-all">
                            {stockist.email}
                          </a>
                        </div>
                      </div>

                      <div className="flex items-start gap-3">
                        <Clock className="w-5 h-5 text-blue-600 flex-shrink-0 mt-1" />
                        <div>
                          <p className="font-semibold text-gray-900 mb-1">Operating Hours</p>
                          <p className="text-gray-700 text-sm">{stockist.operatingHours}</p>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                      <a href={`tel:${stockist.phone}`}>
                        <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white">
                          <Phone className="w-4 h-4 mr-2" /> Call Now
                        </Button>
                      </a>
                      <a href={`mailto:${stockist.email}`}>
                        <Button variant="outline" className="w-full border-2 border-blue-600 text-blue-600 hover:bg-blue-50">
                          <Mail className="w-4 h-4 mr-2" /> Email
                        </Button>
                      </a>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Become Partner CTA */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Want to Become Our Partner?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Join our expanding network of healthcare partners and grow your business with quality pharmaceutical products
          </p>
          <Link to="/become-partner">
            <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all">
              Apply Now <LinkIcon className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Partners;
